import { NgModule } from "@angular/core";
import { MatProgressSpinnerModule, MatAutocompleteModule, MatButtonModule, MatSelectModule, MatOptionModule, MatCardModule, MatTabsModule, MatDialogModule, MatInputModule, MatProgressBarModule, MatTooltipModule } from "@angular/material";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import {MatSlideToggleModule} from '@angular/material/slide-toggle'

@NgModule({
    imports: [MatProgressSpinnerModule, MatButtonModule, FormsModule, ReactiveFormsModule, MatSelectModule, MatCardModule, MatTabsModule, MatOptionModule, MatDialogModule, MatInputModule, MatProgressBarModule, MatExpansionModule, MatAutocompleteModule, MatRadioModule, MatTooltipModule,MatSlideToggleModule],
    exports: [MatProgressSpinnerModule, MatButtonModule, FormsModule, ReactiveFormsModule, MatSelectModule, MatCardModule, MatTabsModule, MatOptionModule, MatDialogModule, MatInputModule, MatProgressBarModule, MatExpansionModule, MatAutocompleteModule, MatRadioModule, MatTooltipModule,MatSlideToggleModule]
})

export class AppMaterialModule { };



// WEBPACK FOOTER //
// ./src/app/app.material.module.ts